import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { Phone, PhonesState } from '@/types';
import { request } from './helper';

// **Thunks**
export const phonesGetAll = createAsyncThunk<Phone[]>(
  'phones/getAll',
  async () => {
    const response = await request('api/phones');
    return response.success ? response.data : [];
  }
);

export const phonesSave = createAsyncThunk<boolean, Partial<Phone>>(
  'phones/save',
  async (data) => {
    const response = await request('api/phones', 'POST', data);
    return response.success;
  }
);

export const phonesUpdate = createAsyncThunk<
  boolean,
  { id: number; data: Partial<Phone> }
>('phones/update', async ({ id, data }) => {
  const response = await request(`api/phones/${id}`, 'PUT', data);
  return response.success;
});

export const phonesDelete = createAsyncThunk<boolean, number>(
  'phones/delete',
  async (id) => {
    const response = await request(`api/phones/${id}`, 'DELETE');
    return response.success;
  }
);

// **Initial State**
const initialState: PhonesState = {
  phones: [],
  fetchAllStatus: 'idle',
  status: 'idle',
};

// **Slice**
const emailSlice = createSlice({
  name: 'email',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    const setLoading = (state: PhonesState) => {
      state.status = 'loading';
    };
    const setFailed = (state: PhonesState) => {
      state.status = 'failed';
    };

    // Get All Phones
    builder
      .addCase(phonesGetAll.pending, (state) => {
        state.fetchAllStatus = 'loading';
      })
      .addCase(phonesGetAll.fulfilled, (state, { payload }: PayloadAction<Phone[]>) => {
        state.fetchAllStatus = 'success';
        state.phones = payload;
      })
      .addCase(phonesGetAll.rejected, (state) => {
        state.fetchAllStatus = 'failed';
      });

    // Save Phones
    builder
      .addCase(phonesSave.pending, setLoading)
      .addCase(phonesSave.fulfilled, (state) => {
        state.status = 'success';
      })
      .addCase(phonesSave.rejected, setFailed);

    // Update Phones
    builder
      .addCase(phonesUpdate.pending, setLoading)
      .addCase(phonesUpdate.fulfilled, (state) => {
        state.status = 'success';
      })
      .addCase(phonesUpdate.rejected, setFailed);

    // Delete Phones
    builder
      .addCase(phonesDelete.pending, setLoading)
      .addCase(phonesDelete.fulfilled, (state) => {
        state.status = 'success';
      })
      .addCase(phonesDelete.rejected, setFailed);
  },
});

// **Export Reducer**
export default emailSlice.reducer;